import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/common/Reveal";
import { useT } from "@/context/LanguageContext";
import { CheckCircle, ArrowRight } from "@phosphor-icons/react";

const PERKS = [
  "Low-MOQ pilot production runs",
  "Custom branding & retail-ready packaging",
  "Amazon FBA prep, labeling & compliance",
  "Dedicated brand manager from day one",
];

export function StartBrand() {
  const { t } = useT();
  const perks = [t("startBrand.p1"), t("startBrand.p2"), t("startBrand.p3"), t("startBrand.p4")];
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="start-brand-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid items-center gap-12 rounded-2xl bg-ink p-8 sm:p-12 lg:grid-cols-2 lg:p-16">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-teal-light">{t("startBrand.overline")}</p>
            <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl">
              {t("startBrand.title")}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-slate-300">
              {t("startBrand.subtitle")}
            </p>
            <ul className="mt-7 space-y-3">
              {perks.map((p) => (
                <li key={p} className="flex items-center gap-3 text-sm text-slate-200">
                  <CheckCircle size={20} weight="fill" className="text-teal-light shrink-0" />
                  {p}
                </li>
              ))}
            </ul>
            <Link
              to="/start-your-brand"
              data-testid="start-brand-cta"
              className="group mt-9 inline-flex items-center gap-2 rounded-md bg-gradient-to-r from-[#1E73BE] to-[#16B894] px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-0.5"
            >
              {t("startBrand.cta")}
              <ArrowRight size={18} weight="bold" className="transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
          <Reveal className="relative">
            <img
              src="https://images.pexels.com/photos/12903168/pexels-photo-12903168.jpeg"
              alt="Private label brand development team"
              className="h-[420px] w-full rounded-xl object-cover"
            />
            <div className="absolute -bottom-5 -left-5 hidden rounded-xl bg-white p-5 shadow-xl sm:block">
              <p className="font-heading text-3xl font-bold text-ink">8–12 wks</p>
              <p className="text-xs text-slate-500">{t("startBrand.badge")}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
